import 'rc-tooltip/assets/bootstrap.css'

import React from "react";
import PropTypes from "prop-types";
import Select, { components } from 'react-select'
import Tooltip from 'rc-tooltip'

const statusFilterOptions = [
  {
    key: 1,
    label: 'Completed',
    value: 'COMPLETED',
    tooltip: 'Parent job has created child jobs.',
    filter: ['COMPLETED'],
  },
  {
    key: 2,
    label: 'Delivered',
    value: 'DELIVERED',
    tooltip: 'Job successfully delivered to receiver.',
    filter: ['DELIVERED'],
  },
  {
    key: 3,
    label: 'Failed',
    value: 'FAILED',
    tooltip: 'Job fails at any step and self-healing was not successful. Will not automatically be retried.',
    filter: ['FAILED'],
  },
  {
    key: 4,
    label: 'In Progress',
    value: 'PROCESSING',
    tooltip: 'Job currently in processing.',
    filter: ['PROCESSING'],
  },
  {
    key: 5,
    label: 'Successful',
    value: 'SUCCESSFUL',
    tooltip: 'Completed or Delivered',
    filter: ["COMPLETED", "DELIVERED"] 
  },
  {
    key: 6,
    label: 'Duplicate',
    value: 'DUPLICATE',
    tooltip: 'Another document exists with matching values. Will not be delivered.',
    filter: ['DUPLICATE'],
  },
  {
    key: 7,
    label: 'Unsuccessful',
    value: 'UNSUCCESSFUL',
    tooltip: 'Failed or Duplicate',
    filter: ["FAILED", "DUPLICATE"],
  },
  {
    key: 8,
    label: 'On Hold',
    value: 'ON_HOLD',
    tooltip: 'Job delivery is paused by a hold. Will automatically be delivered at end of hold period.',
    filter: ["ON_HOLD"],
  },
  {
    key: 9,
    label: 'Cancelled',
    value: 'CANCELLED',
    tooltip: 'Job cancelled by a user. Will not automatically be retried.',
    filter: ['CANCELLED'],
  },
]

const Option = (props) => {
  return (
    <components.Option {...props}>
      <Tooltip placement="right" overlay={<span>{props.data.tooltip}</span>}>
        <div>{props.data.label}</div>
      </Tooltip>
    </components.Option>
  )
}

const JobStatusDropdown = (props) => {
  const value = statusFilterOptions && statusFilterOptions.find(({ filter }) => {
    return props.value
      ? filter.join(',') === props.value.join(',')
      : false
  })

  return (
    <Select
      isClearable
      className="status-dropdown"
      placeholder={props.placeholder}
      options={statusFilterOptions}
      onChange={props.onChange}
      components={{ Option }}
      value={value}
    />
  )
}

JobStatusDropdown.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
}

export default JobStatusDropdown
